<div class="listing pt-4">
  <div class="scroll-container">
    <ng-container *ngFor="let credential of userCredentials; let i = index">
      <div class="form-group rounded-top form-container item">
        <div class="form-group rounded-top form-container">
          <div class="w-100 building-list-container">
            <div class="d-flex list-box full pointer-cursor">
              <span class="align-self-center col-2">
                <img
                  alt="User Icon"
                  src="assets/svg/credential-key.svg"
                  class="left-icon"
                />
              </span>
              <div
                class="d-flex flex-column justify-content-center align-items-center col-8"
              >
                <span class="title bold align-self-center">
                  <app-profile-tooltip [showHelpCursor]="true">
                    {{
                      credential?.cardName
                        ? credential?.cardName
                        : ("NOT_AVAILABLE" | translate)
                    }}
                  </app-profile-tooltip>
                </span>
                <span class="description bold align-self-center">
                  <div
                    class="d-flex flex-row justify-content-start align-items-center"
                  >
                    <div>
                      <strong> {{ "SERIAL_NUMBER_HASH" | translate }}</strong>
                    </div>
                    <div class="pl-1 col-8">
                      <app-profile-tooltip [showHelpCursor]="true">
                        {{
                          " " + credential?.badgeId
                            ? credential?.badgeId
                            : ("NOT_AVAILABLE" | translate)
                        }}
                      </app-profile-tooltip>
                    </div>
                  </div>
                </span>
                <span class="description bold align-self-center">
                  <app-profile-tooltip [showHelpCursor]="true">
                    <strong>{{ "STATUS" | translate }}</strong>
                    <span
                      class="status-pill"
                      [ngClass]="{
                        'status-active':
                          credential?.cardStatus === ('ACTIVE' | translate),
                        'status-pending':
                          credential?.cardStatus === ('PENDING' | translate),
                        'status-blocklisted':
                          credential?.cardStatus ===
                          ('PENDING_BLOCKED' | translate),
                        'status-ready-to-block':
                          credential?.cardStatus === ('BLOCKED' | translate)
                      }"
                    >
                      {{
                        credential?.cardStatus ===
                        ("PENDING_BLOCKED" | translate)
                          ? ("BLOCKLISTED" | translate)
                          : credential?.cardStatus === ("BLOCKED" | translate)
                          ? ("READY_TO_BLOCK" | translate)
                          : credential?.cardStatus
                          ? (credential?.cardStatus | titlecase)
                          : ("NOT_AVAILABLE" | translate)
                      }}
                    </span>
                  </app-profile-tooltip>
                </span>
              </div>

              <span
                class="selected-value-container align-self-center col-2 pr-2"
                (click)="
                  viewCredentialDetails(
                    credential?.cardId,
                    credential?.cardName,
                    credential?.badgeId,
                    credential?.cardStatus,
                    credential?.disable
                  )
                "
              >
                <span class="btn-not-text">
                  <button class="icon-button" type="button">
                    <img
                      class="icon"
                      src="/assets/svg/ico-chevron-forward-outline.svg"
                    />
                  </button>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <!-- MPC-7907 Commented for future use not needed for now -->
  <!--  <div class="d-flex add-credentials pointer-cursor">
    <span class="align-self-center col-2">
      <img
        alt="Credential Icon"
        src="assets/svg/credential-card-grey.svg"
        class="left-icon"
      />
    </span>
    <div
      class="d-flex flex-column justify-content-center align-items-center col-8"
    >
      <span class="title bold align-self-center">
        {{ 'ADD_CREDENTIAL' | translate }}
      </span>
    </div>

    <span
      class="selected-value-container align-self-center col-2 text-right pr-1 pb-1"
    >
      <span class="btn-not-text">
        <button class="icon-button" type="button">
          <img class="icon" src="/assets/svg/ico-add.svg" />
        </button>
      </span>
    </span>
  </div> -->
</div>
